import { FC } from 'react';

import { CommunicationRecipient } from 'types/Communication';

import TableBody from 'modules/_shared/Table/components/TableBody';

import { useCommunicationDetailsPage } from '../context/CommunicationDetailsPageContext';
import RecipientsTableRow from './RecipientsTableRow';

type RecipientsTableBodyProps = {
  isResumeTable?: boolean;
};

const RecipientsTableBody: FC<RecipientsTableBodyProps> = ({
  isResumeTable,
}) => {
  const { data } = useCommunicationDetailsPage();

  const hasData = data.recipients?.length > 0;

  const rows = data.recipients!.map(
    (recipient: CommunicationRecipient, index: number) => (
      <RecipientsTableRow
        key={recipient._id ?? `recipient-row-${index}`}
        index={index}
        recipient={recipient}
        isResumeTable={isResumeTable}
      />
    )
  );

  return <TableBody hasData={hasData} content={rows} noDataMessage="" />;
};

export default RecipientsTableBody;
